import { render, staticRenderFns } from "./DesignPublicationTypeList.vue?vue&type=template&id=675e2009&"
import script from "./DesignPublicationTypeList.vue?vue&type=script&lang=js&"
export * from "./DesignPublicationTypeList.vue?vue&type=script&lang=js&"
import style0 from "./DesignPublicationTypeList.vue?vue&type=style&index=0&id=675e2009&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports